import { IsString, IsBoolean, IsEnum, IsOptional } from 'class-validator';
import { OrganizationType } from '../../../enums/clients/organization-type.enum';

export class UpdateProductOrganizationRoleRequestDto {
    /**
     * Role type for this organization
     * @example 'FABRICATOR'
     */
    @IsOptional()
    @IsEnum(OrganizationType)
    roleType?: OrganizationType;

    /**
     * If multiple organizations for same role, indicates primary
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    isPrimaryForRole?: boolean;

    /**
     * Specific notes for this organization role
     * @example 'Primary fabricator for North American distribution'
     */
    @IsOptional()
    @IsString()
    notes?: string;
} 